import { useEffect, useState } from "react";
import api from "../../../lib/api";
import { Save, Check } from "lucide-react";
import BilingualField from "../BilingualField";
import ImageUploader from "../ImageUploader";

const PAGES = [
  { key: "home", label: "Accueil" },
  { key: "services", label: "Services" },
  { key: "pricing", label: "Tarifs" },
  { key: "gallery", label: "Galerie" },
  { key: "about", label: "À propos" },
  { key: "contact", label: "Contact" },
  { key: "blog", label: "Blog" },
];

export default function SeoEditor() {
  const [seo, setSeo] = useState({});
  const [page, setPage] = useState("home");
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/content/seo").then(({ data }) => setSeo(data || {})).catch(() => setSeo({}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const current = seo[page] || { title: { fr: "", en: "" }, description: { fr: "", en: "" }, og_image: "" };

  const update = (field, value) => {
    setSeo({ ...seo, [page]: { ...current, [field]: value } });
  };

  const save = async () => {
    setLoading(true);
    try {
      await api.put("/content/seo", { data: seo });
      setSaved(true);
      setTimeout(() => setSaved(false), 2200);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="seo-editor">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-serif text-4xl">SEO & Réseaux sociaux</h1>
          <p className="text-[#4A3F35] mt-2">Titre, description et image partagés sur Google, Facebook, LinkedIn…</p>
        </div>
        <button onClick={save} disabled={loading} className="btn-primary disabled:opacity-50" data-testid="seo-save">
          {saved ? <><Check size={16} /> Enregistré</> : <><Save size={16} /> Enregistrer</>}
        </button>
      </div>

      <div className="bg-[#FDFBF7] rounded-2xl p-2 mb-6 flex flex-wrap gap-1 border border-[#2D2A26]/10">
        {PAGES.map((p) => (
          <button key={p.key} onClick={() => setPage(p.key)} className={`px-4 py-2 rounded-xl text-sm transition ${page === p.key ? "bg-[#2D2A26] text-white" : "hover:bg-[#F6F3EC]"}`} data-testid={`seo-page-${p.key}`}>{p.label}</button>
        ))}
      </div>

      <div className="bg-[#FDFBF7] rounded-2xl p-8 border border-[#2D2A26]/10 space-y-5">
        <BilingualField label="Titre (max ~60 caractères)" value={current.title} onChange={(v) => update("title", v)} testid="seo-title" />
        <BilingualField label="Description (max ~160 caractères)" value={current.description} onChange={(v) => update("description", v)} type="textarea" rows={3} testid="seo-description" />
        <ImageUploader label="Image de partage (og:image — idéalement 1200×630)" value={current.og_image} onChange={(v) => update("og_image", v)} testid="seo-og" />
      </div>

      <div className="mt-6 bg-[#F6F3EC] rounded-2xl p-6 border border-[#2D2A26]/10">
        <div className="overline mb-3">Aperçu Google</div>
        <div className="bg-white p-4 rounded-xl">
          <div className="text-[#1a0dab] text-lg truncate">{current.title?.fr || "Titre de votre page"}</div>
          <div className="text-[#006621] text-xs mt-1">saritas-photography.com</div>
          <div className="text-[#4d5156] text-sm mt-1 line-clamp-2">{current.description?.fr || "Description de votre page…"}</div>
        </div>
      </div>
    </div>
  );
}
